import apiClient from 'apiClient';
import withCaseErrorMiddleware from '../caseError/withCaseErrorMiddleware';
import { PatchDefinedContributionResponseData } from '../types';

import { PostResponse, DeleteResponse, PatchResponse } from './types';

const PREFIX = '/api/v1/cases';

export const post = (caseId: string, applicantId: number): PostResponse => {
  return apiClient.post(`${PREFIX}/${caseId}/applicant/${applicantId}/defined-contributions`);
};

export const remove = (caseId: string, applicantId: number, definedContributionId: number): DeleteResponse => {
  return apiClient.delete(
    `${PREFIX}/${caseId}/applicant/${applicantId}/defined-contributions/${definedContributionId}`,
  );
};

export const patch = (
  caseId: string,
  applicantId: number,
  definedContributionId: number,
  field: string,
  value: any,
): PatchResponse => {
  return apiClient
    .patch<PatchDefinedContributionResponseData>(
      `${PREFIX}/${caseId}/applicant/${applicantId}/defined-contributions/${definedContributionId}`,
      {
        [field]: value,
      },
    )
    .then(withCaseErrorMiddleware);
};
